import {
  required,
  maxLength,
  minLength,
  email,
  sameAs,
  numeric,
} from "vuelidate/lib/validators";
const storeMixin = {
  validations: {
    form: {
      name: { required },
      phone_no: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(10),
      },
      desc: { required },
      checkbox: {
        checked(val) {
          return val;
        },
      },
    },
    branch: {
      name: { required },
      phone_no: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(10),
      },
      desc: { required },
    },
  },
  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.form.checkbox.$dirty) return errors;
      const msg = this.$t("validation_required");

      !this.$v.form.checkbox.checked && errors.push(msg);
      return errors;
    },
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");

      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
    phoneNumberError() {
      const errors = [];
      if (!this.$v.form.phone_no.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.phone_no.required && errors.push(msg);

      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }
      return errors;
    },
    descError() {
      const errors = [];
      if (!this.$v.form.desc.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.desc.required && errors.push(msg);
      return errors;
    },
    branchNameError() {
      const errors = [];
      if (!this.$v.branch.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.branch.name.required && errors.push(msg);
      return errors;
    },
    branchPhoneNumberError() {
      const errors = [];
      if (!this.$v.branch.phone_no.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.branch.phone_no.required && errors.push(msg);
      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }

      return errors;
    },
    branchDescError() {
      const errors = [];
      if (!this.$v.branch.desc.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.branch.desc.required && errors.push(msg);
      return errors;
    },
  },
};

const addProduct = {
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
      },
      name: { required },
      price_sale: {}, // Optional field
      price_buy: {}, // Optional field
      category_id: { required },
      vendor_id: {}, // Optional field
      size_id: {}, // Optional field
      currency_id: { required },
    },
  },
  computed: {
    codeError() {
      const errors = [];
      if (!this.$v.form.code.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.code.required && errors.push(msg);
      if (!this.$v.form.code.minLength) {
        const msg = this.$t("code_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.code.maxLength) {
        const msg = this.$t("code_max_length");
        errors.push(msg);
      }
      return errors;
    },
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },

    category_idError() {
      const errors = [];
      if (!this.$v.form.category_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.category_id.required && errors.push(msg);
      return errors;
    },
  },
};
const CategoryValidate = {
  validations: {
    form: {
      la_name: { required },
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.form.la_name.$dirty) return errors;
      if (!this.$v.form.la_name.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
  },
};
const sizeValidate = {
  validations: {
    form: {
      name: { required },
      unit: { required },
      amount: { required },
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
    unitError() {
      const errors = [];
      if (!this.$v.form.unit.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.unit.required && errors.push(msg);
      return errors;
    },
    amountError() {
      const errors = [];
      if (!this.$v.form.amount.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.amount.required && errors.push(msg);
      return errors;
    },
  },
};
const expenseCatValidate = {
  validations: {
    form: {
      name: { required },
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      if (!this.$v.form.name.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
  },
};
const expenseValidate = {
  validations: {
    form: {
      name: { required },
      price: { required },
      category_id: { required },
      type: { required },
    },
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
    priceError() {
      const errors = [];
      if (!this.$v.form.price.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.price.required && errors.push(msg);
      return errors;
    },
    category_idError() {
      const errors = [];
      if (!this.$v.form.category_id.$dirty) return errors;
      if (!this.$v.form.category_id.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
    typeError() {
      const errors = [];
      if (!this.$v.form.type.$dirty) return errors;
      if (!this.$v.form.type.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
  },
};

const cashTransactionValidate = {
  validations: {
    form: {
      amount: { required },
      type: { required },
    },
  },
  computed: {
    amountError() {
      const errors = [];
      if (!this.$v.form.amount.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.amount.required && errors.push(msg);
      return errors;
    },
    typeError() {
      const errors = [];
      if (!this.$v.form.type.$dirty) return errors;
      if (!this.$v.form.type.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
  },
};
const customerValidate = {
  validations: {
    form: {
      first_name: { required },
      phone_no: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(10),
      },

      logistics_id: { required },
      province_id: { required },
      district_id: { required },
      village_id: { required },
    },
  },
  computed: {
    first_nameError() {
      const errors = [];
      if (!this.$v.form.first_name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.first_name.required && errors.push(msg);
      return errors;
    },
    phone_numberError() {
      const errors = [];
      if (!this.$v.form.phone_no.$dirty) return errors;
      if (!this.$v.form.phone_no.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }
      return errors;
    },

    logistics_idError() {
      const errors = [];
      if (!this.$v.form.logistics_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.logistics_id.required && errors.push(msg);
      return errors;
    },
    province_idError() {
      const errors = [];
      if (!this.$v.form.province_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.province_id.required && errors.push(msg);
      return errors;
    },
    district_idError() {
      const errors = [];
      if (!this.$v.form.district_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.district_id.required && errors.push(msg);
      return errors;
    },
    village_idError() {
      const errors = [];
      if (!this.$v.form.village_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.village_id.required && errors.push(msg);
      return errors;
    },
  },
};

const returnProduct = {
  validations: {
    body: {
      return_type: { required },
      remark: { required },
    },
  },
  computed: {
    return_typeError() {
      const errors = [];
      if (!this.$v.body.return_type.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.body.return_type.required && errors.push(msg);
      return errors;
    },
    remarkError() {
      const errors = [];
      if (!this.$v.body.remark.$dirty) return errors;
      if (!this.$v.body.remark.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      return errors;
    },
  },
};

const AddUserStore = {
  validations: {
    form: {
      first_name: { required },
      role: { required },
      branch_id: { required },
      phone_no: { required, minLength: minLength(8), maxLength: maxLength(10) },
      password: { required, minLength: minLength(8) },
      confirm_password: { required, sameAsPassword: sameAs("password") },
      email: {
        email,
        required,
      },
    },
    formChange: {
      password: { required, minLength: minLength(8) },
      confirm_password: { required, sameAsPassword: sameAs("password") },
    },
  },

  computed: {
    first_nameError() {
      const errors = [];
      if (!this.$v.form.first_name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.first_name.required && errors.push(msg);
      return errors;
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.form.role.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.role.required && errors.push(msg);
      return errors;
    },
    branch_idErrors() {
      const errors = [];
      if (!this.$v.form.branch_id.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.branch_id.required && errors.push(msg);
      return errors;
    },
    phone_numberError() {
      const errors = [];
      if (!this.$v.form.phone_no.$dirty) return errors;

      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      if (!this.$v.form.email.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      if (!this.$v.form.email.email) {
        const msg = this.$t("email_invalid");
        errors.push(msg);
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      if (!this.$v.form.password.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      if (!this.$v.form.password.minLength) {
        const msg = this.$t("password_min_length");
        errors.push(msg);
      }
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.form.confirm_password.$dirty) return errors;
      if (!this.$v.form.confirm_password.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }

      if (!this.$v.form.confirm_password.sameAsPassword) {
        const msg = this.$t("password_not_match");
        errors.push(msg);
      }
      return errors;
    },
    passwordErrorsC() {
      const errors = [];
      if (!this.$v.formChange.password.$dirty) return errors;
      if (!this.$v.formChange.password.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      if (!this.$v.formChange.password.minLength) {
        const msg = this.$t("password_min_length");
        errors.push(msg);
      }
      return errors;
    },
    confirmPasswordErrorsC() {
      const errors = [];
      if (!this.$v.formChange.confirm_password.$dirty) return errors;
      if (!this.$v.formChange.confirm_password.required) {
        const msg = this.$t("validation_required");
        errors.push(msg);
      }
      if (!this.$v.formChange.confirm_password.sameAsPassword) {
        const msg = this.$t("password_not_match");
        errors.push(msg);
      }

      return errors;
    },
  },
};

const VENDOR = {
  validations: {
    form: {
      name: { required },
      address: { required },
      phone_no: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(10),
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.form.address.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.address.required && errors.push(msg);
      return errors;
    },
    phone_noErrors() {
      const errors = [];
      if (!this.$v.form.phone_no.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.phone_no.required && errors.push(msg);
      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }
      return errors;
    },
  },
};

const BRANCHES = {
  validations: {
    form: {
      name: { required },
      address: { required },
      phone_no: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(10),
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.form.address.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.address.required && errors.push(msg);
      return errors;
    },
    phone_noErrors() {
      const errors = [];
      if (!this.$v.form.phone_no.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.phone_no.required && errors.push(msg);
      if (!this.$v.form.phone_no.minLength) {
        const msg = this.$t("phone_min_length");
        errors.push(msg);
      }
      if (!this.$v.form.phone_no.maxLength) {
        const msg = this.$t("phone_max_length");
        errors.push(msg);
      }
      return errors;
    },
  },
};

const TABLE_VALIDATE = {
  validations: {
    form: {
      name: { required },
    },
  },

  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      const msg = this.$t("validation_required");
      !this.$v.form.name.required && errors.push(msg);
      return errors;
    },
  },
};

export {
  expenseValidate,
  cashTransactionValidate,
  customerValidate,
  storeMixin,
  addProduct,
  CategoryValidate,
  sizeValidate,
  returnProduct,
  expenseCatValidate,
  AddUserStore,
  VENDOR,
  BRANCHES,
  TABLE_VALIDATE,
};
